module.exports = __webpack_public_path__ + "img/2-7-lvcc.069d2458.jpg";